define.alias("shared/components/shared/wizards/device-setup", "settings/components/shared/wizards/device-setup");